import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Typography } from "@mui/material";

function OpeningHours({ openingHours }) {
  return (
    <>
      <ListItem>
        <ListItemAvatar>
          <Avatar>
            <AccessTimeIcon />
          </Avatar>
        </ListItemAvatar>
        <Typography component="div" sx={{ fontSize: "2rem", fontWeight: 500  }}>
          Otváracie hodiny
        </Typography>
      </ListItem>
      <ListItem sx={{ pl: 4 }}>
        <Typography component={"div"} sx={{ fontSize: "1.8rem" }}>
          {openingHours.from} - {openingHours.to}
        </Typography>
      </ListItem>
    </>
  );
}

export default OpeningHours;
